module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAA0klEQVQokZ3TPUoDURQG0KPTaOUPWImWgoK4CnUJ1m7AOkvIAuxdg03AWLgAS0HBTtBWnSwgyodvYCwS4/vgFQNz3tzh3rvkd5ZxjFMcYgMfeMANbjHtRB9vY4h9s/OEAd76OPAKm3Ngl3ec54KmlHqJ3QVgsoojXDfl/84WhF228BJ8gZ1/4mQlJR9UwGQveL0SrwV/VuI2+LESPwePKvEoeFzx9bw/Tqu+cI+TMgB/JROW9rbByQR3ZXIyALOS2Q58zcO8rcqCpI1tV2Y5P1uFb7OGJPQtwDF5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/mobile/black_radio.png
// module id = HrIJ
// module chunks = 1